(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-blog-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('pointermove', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.sw-bc__card') : null; if (!card) return;
    var r = card.getBoundingClientRect(); var a = Math.atan2(e.clientY - (r.top + r.height / 2), e.clientX - (r.left + r.width / 2));
    card.style.setProperty('--sw-rot', a + 'rad');
  });
  document.addEventListener('pointerleave', function (e) { var c = e.target && e.target.closest ? e.target.closest('.sw-bc__card') : null; if (c) c.style.removeProperty('--sw-rot'); }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-scent-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.swQzReady) return; root.dataset.swQzReady = '1';
      var track = root.querySelector('[data-sw-qz-track]');
      var dots = root.parentElement.querySelector('[data-sw-qz-dots]');
      var slides = track ? track.children : [];
      if (!track || !slides.length) return;
      function step() { return slides[0].getBoundingClientRect().width + 16; }
      function index() { return Math.round(track.scrollLeft / step()); }
      function go(i) { track.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, i)) * step(), behavior: 'smooth' }); }
      root.querySelector('[data-sw-qz-prev]').addEventListener('click', function () { go(index() - 1); });
      root.querySelector('[data-sw-qz-next]').addEventListener('click', function () { go(index() + 1); });
      function paint() {
        var i = index();
        if (dots) Array.prototype.forEach.call(dots.children, function (d, n) { d.classList.toggle('is-on', n === i); });
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
      paint();
    }
    function boot() { document.querySelectorAll('[data-sw-qz]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-stain-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-sw-st-btn]') : null;
      if (!btn) return;
      var root = btn.closest('[data-sw-st]'); if (!root) return;
      var i = btn.getAttribute('data-sw-st-btn');
      root.querySelectorAll('[data-sw-st-btn]').forEach(function (b) {
        var on = b === btn; b.classList.toggle('is-on', on); b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-sw-st-panel]').forEach(function (p) {
        p.classList.toggle('is-on', p.getAttribute('data-sw-st-panel') === i);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
